import cx from 'classnames'
import Link from 'next/link'

import ROUTES from 'config/routes.json'
import { getProviderColor } from 'pageContainers/GameLandingPage/utils/getProviderColor'
import type { SupportedCurrencies } from 'types/currencies'

import Badge from '../Badge'
import classes from '../GameInfo/styles.module.scss'

type Props = {
  isDarkMode: boolean
  activeCurrency: SupportedCurrencies
  isLoggedIn: boolean
  providerCode: string
  title: string
}

export default function Provider(props: Props) {
  const { activeCurrency, isLoggedIn, isDarkMode, providerCode, title } = props
  const providerLink = `${ROUTES.PROVIDERS}/${providerCode}`
  const providerColor = getProviderColor(activeCurrency, isLoggedIn)

  return (
    <Link className={cx(classes.gameInfoCol, isDarkMode && classes.darkMode)} href={providerLink} prefetch={false}>
      <Badge activeCurrency={activeCurrency} isLoggedIn={isLoggedIn} />
      <span className={cx('mt-typography-caption', classes.caption, isDarkMode && classes.captionDarkMode)}>
        {title}
      </span>
      <div className={classes.providerContainer}>
        <img
          alt='provider-name'
          src={`${process.env.IMG_ORIGIN}/game-description/providers/${providerColor}/dark/${providerCode}.png`}
          className={classes.providerIcon}
        />
      </div>
    </Link>
  )
}
